module.exports = __webpack_public_path__ + "img/celebration.3ac46da4.png";